import { render } from "./A00017.vue?vue&type=template&id=006ae8c3&ts=true"
import script from "./A00017.vue?vue&type=script&lang=ts"
export * from "./A00017.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__